export const defaultTranslations = 'Information';

export type Translations = typeof defaultTranslations;
